module.exports = __webpack_public_path__ + "static/media/content1.3d0ee134.jpg";